import React, { useState } from "react";
import { Formik, Form } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { StepButton } from "./stepButton";
import * as Yup from "yup";
import {
  ModalBody
} from "reactstrap";
import { store } from "../../../redux/storeConfig/store";
import { createGate, startStaffSession } from "../../../redux/actions/api/apiAction";
import Title from "../../title";
import SpinnerComponent from "../../spinner/spinner";


function MultiStepForGate({
  cashId,
  startCashOnSite,
  handleSubmit
}) {
  const [isLoading, setIsLoading] = useState(false);

  handleSubmit = async (values) => {
    console.log('values start session:', values);
    setIsLoading(true);
    await store.dispatch(startStaffSession({
      cashId: values.cashId,
      startCashOnSiteAmount: values.startCashOnSite,
    }));
    setIsLoading(false);
  };

  const formSchema = Yup.object().shape({
    cashId: Yup.number()
      .typeError("Cash name is required")
      .required("Cash name is required"),
      startCashOnSite: Yup.number()
      .typeError("Cash on site is required")
      .min(0, "Cash on site cannot be less than 0")
      .required("Cash on site is required"),
  });

  return (
    <>
      <ModalBody className="wod-first-step">
        <div className="modal-body-content">
          <div className="add-member-popup adding-popup bg-white card-panel">
            {/* <div className="basic-info" style={{height: "50vh"}}> */}
            <div className="basic-info">
              <div className="info-title with-border">
                <Title
                  title="Start Staff Session"
                  subtitlestyle="ctf-tx-secondary"
                  subtitle="Add info about the session"
                />
              </div>
              {isLoading ?
                  <div
                    style={{ height: "90%" }}
                    className="d-flex flex-column align-items-center justify-content-center"
                  >
                    <SpinnerComponent />
                    <h3>Please wait</h3>
                </div>
                :
                <Formik
                  enableReinitialize
                  initialValues={{
                    cashId,
                    startCashOnSite
                  }}
                  onSubmit={handleSubmit}
                  validationSchema={formSchema}
                >
                  {({
                    errors,
                    touched,
                    values,
                    setFieldValue,
                  }) => (
                    <Form className="d-flex flex-column justify-content-between h-100">
                      <FormFirstStep
                        errors={errors}
                        touched={touched}
                        values={values}
                        setFieldValue={setFieldValue}
                      />
                      <StepButton/>
                    </Form>
                  )}
                </Formik>
              }
            </div>
          </div>
        </div>
      </ModalBody>
    </>
  );
};

MultiStepForGate.defaultProps = {
  cashId: null,
  startCashOnSite: null,
  handleSubmit: () => {}
};

export default MultiStepForGate;
